var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "kt_header",
      staticClass: "header",
      class: _vm.headerClasses,
      attrs: { id: "kt_header" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "container-fluid d-flex align-items-center justify-content-between",
        },
        [
          _c(
            "div",
            {
              ref: "kt_header_menu_wrapper",
              staticClass: "header-menu-wrapper header-menu-wrapper-left",
            },
            [
              _vm.headerMenuEnabled
                ? _c(
                    "div",
                    {
                      ref: "kt_header_menu",
                      staticClass: "header-menu header-menu-mobile",
                      class: _vm.headerMenuClasses,
                      attrs: { id: "kt_header_menu" },
                    },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "text-dark font-weight-bold my-2 mr-5 page-title",
                        },
                        [_vm._v(" " + _vm._s(_vm.title) + " ")]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _c("div", {
            staticStyle: { display: "none" },
            attrs: { id: "kt_aside_mobile_toggle" },
          }),
          _c("div", {
            staticStyle: { display: "none" },
            attrs: { id: "kt_aside_close_btn" },
          }),
          _c("KTTopbar"),
          _c("AppointmentForm"),
          _c("BlockTimeForm"),
          _c("MobileClientSelect"),
          _c("MobileSubjectSelect"),
          _c("MobileServiceSelect"),
          _c("DateInput"),
          _c("AvailabilityInput"),
          _c("OpeningHoursForm"),
          _c("DeleteClientModal"),
          _c("DeleteSubjectModal"),
          _c("DeleteStaffModal"),
          _c("MultipleClientSelect"),
          _vm.overlayShow
            ? _c("div", { staticClass: "offcanvas-overlay" })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }